const { cELM, debounce, Wrap4Arrow } = require("../../utils");
const Scroller = require("../scroller");
const Chat = require("../../chat");
const sanitizer = require('../../utils/sanitizer');

class AddressInput {
  constructor(data) {
    this._data = data;
    this.element = cELM("div", "option-block autocomplete");
    this.__elements = null;
    this.keyword = "";

    this.addressLookup = null;
    this.detailLookup = null;

    this._map = null;

    this._addressObj = null;
    this._zip = "";
    this._address = "";

    /**
     * GO: Some clients utilize this module to retrieve pharmacy-related data from the Google API. 
     * We need to implement a mechanism to detect whether incoming questions are related to pharmacy.
     * It will allow us to apply appropriate filters.
     */
    if (data) {
      const text = typeof data.text === 'string' ? data.text.toLowerCase() : '';
      const subtext = typeof data.subtext === 'string' ? data.subtext.toLowerCase() : '';

      this._is_pharmacy_question = text.includes('pharmacy') || subtext.includes('pharmacy');
    }

    this.createElement();
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  createElement() {
    const _self = this;
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE '); //IE 10 check

    if (msie == -1 && google) {
      const placeHolderMap = cELM("div", "placeHolderMap");

      this.addressLookup = new google.maps.places.AutocompleteService();
      this._map = new google.maps.Map(placeHolderMap, {
        center: { lat: 0, lng: 0 },
        zoom: 10,
        styles: [
          {
            stylers: [{ visibility: "simplified" }],
          },
          {
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      });
      this.detailLookup = new google.maps.places.PlacesService(this._map);
    } else {
      console.warn("Cannot find google object");
      if (msie > -1)
      console.warn("IE 10")
    }

    const inputContainer = cELM("div", "inputs-wrapper");
    const searchBlock = cELM("div", "search-block");
    const inputEl = cELM("input", "text-input search-input");
    inputEl.placeholder = getLngTxt("input.placeholder.fulladdress");

    const buttonEl = cELM("div", "go-button go-button-active", getLngTxt("button.submit"));

    const handleKeyUp = function(event) {
      _self.keyword = sanitizer.sanitizeString(event.target.value || '');

      if (event.key === "Enter") {
        buttonEl.click();
      }

      let params = {
        input: _self.keyword,
        types: ["address"],
        componentRestrictions: { country: "us" },
      };

      //AR: Allow user to type "TEST Street or 123 Street or 1-2 1st"
      if (
        _self.keyword &&
        _self.keyword.split(" ").length >= 2 &&
        _self.keyword.split(" ")[1].trim().length >= 1
      ) {
        buttonEl.classList.add("continue-button-active");
      }

      if (_self._data.format === "address-entity") {
        params.types = ["establishment"];
      }
      
      if (msie == -1) { //remove autocomplete for IE 10
        _self.addressLookup.getPredictions(params, function(predictions, status) {
          // console.log(predictions, status);
          if (!searchBlock.classList.contains("search-block-active")) {
            Scroller.smoothScrollTo(window.scrollY + 175);
          }
          searchBlock.classList.add("search-block-active");

          var child = searchBlock.lastElementChild;
          while (child) {
            searchBlock.removeChild(child);
            child = searchBlock.lastElementChild;
          }

          if (!predictions) {
            const _el = cELM("div", "search-item", _self.keyword);
            _el.onclick = function() {
              inputEl.value = _self.keyword;
              searchBlock.classList.remove("search-block-active");
              buttonEl.classList.add("continue-button-active");
            };
            searchBlock.addELM(_el);
            return;
          }

          // Filter out predictions that aren't addresses
          if (!_self._is_pharmacy_question) {
            predictions = predictions.filter((prediction) => prediction.types.includes('premise') || prediction.types.includes('street_address'));
          }

          predictions.forEach(p => {
            const _el = cELM("div", "search-item", p.description.replace(", USA", ""));
            _el.onclick = function() {
              _self.keyword = p.description;
              inputEl.value = p.description;
              searchBlock.classList.remove("search-block-active");
              buttonEl.classList.add("continue-button-active");

              _self.detailLookup.getDetails({ placeId: p.place_id }, function(result) {
                // console.log(result);
                _self._addressObj = result;
                if (result.geometry.location) _self._map.setCenter(result.geometry.location);

                for (var i = 0; i < result.address_components.length; i++) {
                  var cp = result.address_components[i];
                  if (JSON.stringify(cp.types).indexOf("postal_code") > -1) {
                    _self.zip = cp.long_name;
                    break;
                  }
                }

                _self._address = p.description.replace(", USA", " " + _self.zip);
                buttonEl.click();
              });

              _self._addressObj = p;
            };
            searchBlock.addELM(_el);
          });
        });
      }

    };
    


    inputEl.onkeyup = debounce(handleKeyUp, 200);

    buttonEl.onclick = function(evt) {
      buttonEl.classList.remove("continue-button-active");
      inputEl.value = sanitizer.sanitizeString(inputEl.value);
      if (inputEl.value.trim() === "") {
        return;
      }

      /*
answer: {content: "123 test", meta: "address", entered: "123 test"}
content: "123 test"
entered: "123 test"
meta: "address"
        */

      /*
content: "195 98th Avenue, Oakland, CA 94603"
meta: {address_components: [{long_name: "195", short_name: "195", types: ["street_number"]},…],…}
address_components: [{long_name: "195", short_name: "195", types: ["street_number"]},…]
adr_address: "<span class="street-address">195 98th Ave</span>, <span class="locality">Oakland</span>, <span class="region">CA</span> <span class="postal-code">94603-1003</span>, <span class="country-name">USA</span>"
formatted_address: "195 98th Ave, Oakland, CA 94603, USA"
geometry: {location: {lat: 37.7303206, lng: -122.19244579999997},…}
html_attributions: []
icon: "https://maps.gstatic.com/mapfiles/place_api/icons/geocode-71.png"
id: "ad8fb5d7cdaae3e88618e1633cac24891434f17c"
name: "195 98th Ave"
place_id: "ChIJU80A1J6Fj4ARc-jUEkkw-DM"

          */
      inputEl.blur();

      if (_self._addressObj) {
        Chat.default.send(
          {
            id:_self._data.id,
            content: _self._address,
            meta: _self._addressObj,
          },
          null,
          _self.element,
        );
      } else {
        //AR send what the user typed to the server andle the rest later
        Chat.default.send(
          {
            id:_self._data.id,
            content: _self.keyword,
            entered: _self.keyword,
            meta: "address",
          },
          null,
          _self.element,
        );
      }
    };

    inputContainer.addELM(Wrap4Arrow(inputEl, true));
    inputContainer.addELM(buttonEl);
    this.element.addELM(searchBlock);
    this.element.addELM(inputContainer);

    this.__elements = {
      inputEl,
    };

    return this.element;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.inputEl.value = "";

    this.addressObj = null;
    this.keyword = "";
  }

  focus() {
    if (!this.__elements) return;
    //this.__elements.inputEl.focus();
  }
}

module.exports = AddressInput;
